export default __webpack_public_path__ + "static/media/ChineduNzetehCV.add3bedb.pdf";